export const PRICE_INDICATOR_VALUE_RANK = {
  first: 1,
  second: 2,
  third: 3,
  fourth: 4,
  fifth: 5
}

export const PRICE_INDICATOR_LABEL_RANK = {
  [PRICE_INDICATOR_VALUE_RANK.first]: 'Precio alto',
  [PRICE_INDICATOR_VALUE_RANK.second]: 'Precio elevado',
  [PRICE_INDICATOR_VALUE_RANK.third]: 'Precio justo',
  [PRICE_INDICATOR_VALUE_RANK.fourth]: 'Buen precio',
  [PRICE_INDICATOR_VALUE_RANK.fifth]: 'Super precio'
}

export const PRICE_INDICATOR_COLOR_RANK = {
  [PRICE_INDICATOR_VALUE_RANK.first]: 'red',
  [PRICE_INDICATOR_VALUE_RANK.second]: 'yellow',
  [PRICE_INDICATOR_VALUE_RANK.third]: 'green',
  [PRICE_INDICATOR_VALUE_RANK.fourth]: 'green',
  [PRICE_INDICATOR_VALUE_RANK.fifth]: 'green'
}

export const PRICE_INDICATOR_VISIBLE_RANKS = [
  PRICE_INDICATOR_VALUE_RANK.third,
  PRICE_INDICATOR_VALUE_RANK.fourth,
  PRICE_INDICATOR_VALUE_RANK.fifth
]
